import React, { useState } from "react"
import { Descriptions, Divider, Drawer, Typography } from "antd"
import moment from "moment/moment"
import TapeOrderFillForm from "./TapeOrderFillForm"

const { Link } = Typography

export default function TapeOrderFill({ order }) {
  const [open, setOpen] = useState(false)
  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  if (!order) {
    return <p>loading..</p>
  }
  return (
    <>
      <Link type="primary" onClick={showDrawer}>
        Fill Order
      </Link>
      <Drawer title="Order Fill" placement="left" onClose={onClose} open={open}>
        <Divider>Details</Divider>
        <Descriptions size="small" column={1}>
          <Descriptions.Item label="Client">{order.client.client}</Descriptions.Item>
          <Descriptions.Item label="Product">
            {order.selectedProduct.product.productName}
          </Descriptions.Item>
          <Descriptions.Item label="User">{order.user}</Descriptions.Item>
          <Descriptions.Item label="Roll Count">{order.rollCount}</Descriptions.Item>
          <Descriptions.Item label="Box Count">{order.boxCount}</Descriptions.Item>
          <Descriptions.Item label="Manufacturer">{order.manufacturer.company}</Descriptions.Item>
          <Descriptions.Item label="Creation Date">
            {order && moment.unix(order.created.seconds).format("DD/MM/YYYY")}
          </Descriptions.Item>
        </Descriptions>
        <Divider>File </Divider>
        <Descriptions size="small" column={1}>
          <Descriptions.Item label="User File">
            <Link href={order.selectedProduct.product.productFileUrl} target="_blank">
              Link
            </Link>
          </Descriptions.Item>
        </Descriptions>
        <Divider>Actions </Divider>
        <TapeOrderFillForm order={order} setOpen={setOpen} />
      </Drawer>
    </>
  )
}
